<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.auth-wrapper {
  .login-bg {
    background-size: cover;
    background-position: center;
  }
}

.login-card {
  width: 100%;
  max-width: 700px;
  height: 400px;

  &__bg {
    background-size: cover;
    background-position: center;

    img {
      @include positioningOffset(absolute, 15px, 5px, unset, unset);
      width: 100px;
      height: auto;
    }
  }
}
</style>

<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <!--      <div class="brand-logo">-->
      <!--        <img width="100px" height="auto" src="~@/assets/images/logo/logo.svg" alt="logo">-->
      <!--      </div>-->
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5 login-bg"
      >
        <b-card class="login-card mx-auto">
          <div class="full-width login-card__bg p-relative" style="height: 100%;" :style="{'backgroundImage': 'url(' + bgImage + ')'}">
            <img width="100%" height="100%" src="~@/assets/images/logo/logo.svg" alt="logo">
          </div>
        </b-card>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Welcome to Purple Post for Residents
          </b-card-title>
          <b-card-text class="mb-2">
            Please sign-in to your account
          </b-card-text>

          <b-card-text v-if="hasLoginError" class="mt-2" type="warning" style="color: red">
            {{tooManyAttempts ? 'You have made too many login requests and are temporarily locked out. Please wait a while before retrying.' :
            'Username or password incorrect, please try again'}}
          </b-card-text>
          <b-card-text v-if="hasInternalError" class="mt-2" type="warning" style="color: red">
            Something went wrong, probably at our end. Please contact your support team
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="Username"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Username"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="username"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="username"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <!--                  <b-link :to="{name:'auth-forgot-password-v2'}">-->
                  <!--                    <small>Forgot Password?</small>-->
                  <!--                  </b-link>-->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                Sign in
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { logger } from '../util/logger'
import AnalystUsersService from '../services/AnalystUsersService'

export default {
  components: {},
  mixins: [togglePasswordVisibility],
  data() {
    return {
      hasLoginError: false,
      hasInternalError: false,
      isLoggingIn: false,
      password: '',
      username: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      bgImage: require('@/assets/images/pages/login-bg.jpg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      tooManyAttempts: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    validationForm() {
      this.$refs.loginValidation.validate()
        .then(success => {
          if (success) {
            this.$store.dispatch('auth/clearLocalUser')

            setTimeout(() => {
              this.login()
            })
          }
        })
    },
    login() {
      this.hasLoginError = false
      this.hasInternalError = false

      AnalystUsersService.login(this.username.toLowerCase(), this.password)
        .then(res => {
          this.$store.dispatch('auth/setLocalUserToken', res.data.token)

          this.getUser()
        })
        .catch(error => {
          console.log('error', error, 'err res', error.response)
          this.hasLoginError = error.response.status < 500
          this.hasInternalError = error.response.status >= 500
          this.tooManyAttempts = error.response.status === 429
        })
    },
    getUser() {
      AnalystUsersService.getUser()
        .then(res => {
          const user = res.data

          // Check the user has correct type
          if (user.type !== 'AnalystUser') {
            logger.warn('User is not of correct type', null, {
              user,
              expectedType: 'AnalystUser'
            }, 'Login:getUser')
            // Clear the token and display an error
            this.$store.dispatch('auth/clearLocalUser')
            this.$store.commit('auth/SET_USER', null)
            this.isLoggingIn = false
            this.hasLoginError = true
            this.hasInternalError = false
          } else {
            this.$store.dispatch('auth/setLocalUser', user)
            // Push to dashboard
            this.$router.push({ name: 'dashboard' })
          }
        })
        .catch(err => {
          logger.error('Error getting user', err, { username: this.username }, 'Login:getUser')
          this.isLoggingIn = false
          this.hasLoginError = err.response.status < 500
          this.hasInternalError = err.response.status >= 500
        })
    },
  },
}
</script>
